// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index__xkl7kBQQ[class]{background:var(--field-background)}.index__xkl7kBQQ[class] .index_month__xkl7kBQQ[size$=mini]{width:65px}.index_body__xkl7kBQQ{padding:12px 0;overflow:auto}", ""]);
// Exports
exports.locals = {
	"root": "index__xkl7kBQQ",
	"month": "index_month__xkl7kBQQ",
	"body": "index_body__xkl7kBQQ"
};
module.exports = exports;
